<template>
  <main class="login-page">
    <section class="login-visual">
      <router-link class="brand" to="/">晴屿集</router-link>
      <div>
        <p class="eyebrow">后台管理</p>
        <h1>登录后管理文章和站点资料。</h1>
      </div>
    </section>

    <section class="login-panel" aria-label="后台登录">
      <el-form class="login-form" @submit.native.prevent="submit">
        <div class="login-form-heading">
          <div>
            <p class="eyebrow">Admin Login</p>
            <h2>欢迎回来</h2>
          </div>
          <router-link class="login-back-link" to="/">返回前台</router-link>
        </div>

        <el-form-item label="用户名">
          <el-input
            v-model.trim="form.username"
            autocomplete="username"
            placeholder="请输入用户名"
            type="text"
          />
        </el-form-item>

        <el-form-item label="密码">
          <el-input
            v-model="form.password"
            autocomplete="current-password"
            placeholder="请输入密码"
            show-password
            type="password"
          />
        </el-form-item>

        <el-form-item label="邮箱验证码">
          <div class="login-code-row">
            <el-input
              class="login-code-input"
              v-model.trim="form.verificationCode"
              autocomplete="one-time-code"
              maxlength="6"
              placeholder="6 位验证码"
              type="text"
            />
            <el-button
              class="login-code-button"
              :disabled="codeButtonDisabled"
              :loading="sendingCode"
              native-type="button"
              @click="sendCode"
            >
              {{ codeButtonText }}
            </el-button>
          </div>
        </el-form-item>

        <el-button class="login-button" type="primary" native-type="submit" :loading="loading">
          登录
        </el-button>
      </el-form>
    </section>
  </main>
</template>

<script>
import { loginAdmin, sendAdminLoginCode } from '@/services/auth';

export default {
  name: 'AdminLogin',
  data() {
    return {
      loading: false,
      sendingCode: false,
      codeCountdown: 0,
      codeTimer: null,
      error: '',
      form: {
        username: '',
        password: '',
        verificationCode: '',
      },
    };
  },
  computed: {
    codeButtonDisabled() {
      return this.sendingCode || this.codeCountdown > 0 || !this.form.username || !this.form.password;
    },
    codeButtonText() {
      if (this.codeCountdown > 0) {
        return `${this.codeCountdown}s 后重发`;
      }
      return '获取验证码';
    },
  },
  beforeDestroy() {
    this.clearCodeTimer();
  },
  methods: {
    validateCredentials() {
      if (!this.form.username || !this.form.password) {
        return '请输入用户名和密码';
      }
      return '';
    },
    validateLoginForm() {
      const credentialsError = this.validateCredentials();
      if (credentialsError) {
        return credentialsError;
      }
      if (!this.form.verificationCode) {
        return '请输入邮箱验证码';
      }
      return '';
    },
    async sendCode() {
      const error = this.validateCredentials();
      if (error) {
        this.error = error;
        this.$message.warning(error);
        return;
      }

      this.sendingCode = true;
      this.error = '';

      try {
        await sendAdminLoginCode({
          username: this.form.username,
          password: this.form.password,
        });
        this.$message.success('验证码已发送，请查看绑定邮箱');
        this.startCodeCountdown();
      } catch (error) {
        this.error = error.code === 'ECONNABORTED'
          ? '验证码发送时间较长，请稍后重试；如果持续失败，请检查邮箱服务配置'
          : error.response?.data?.message || error.message || '验证码发送失败';
        this.$message.error(this.error);
      } finally {
        this.sendingCode = false;
      }
    },
    startCodeCountdown() {
      this.clearCodeTimer();
      this.codeCountdown = 60;
      this.codeTimer = window.setInterval(() => {
        this.codeCountdown -= 1;
        if (this.codeCountdown <= 0) {
          this.clearCodeTimer();
        }
      }, 1000);
    },
    clearCodeTimer() {
      if (this.codeTimer) {
        window.clearInterval(this.codeTimer);
        this.codeTimer = null;
      }
      if (this.codeCountdown < 0) {
        this.codeCountdown = 0;
      }
    },
    async submit() {
      const validationError = this.validateLoginForm();
      if (validationError) {
        this.error = validationError;
        this.$message.warning(this.error);
        return;
      }

      this.loading = true;
      this.error = '';

      try {
        await loginAdmin(this.form);
        const redirect = this.$route.query.redirect || '/admin';
        this.$router.replace(redirect);
      } catch (error) {
        this.error = error.response?.data?.message || error.message || '登录失败，请检查账号密码';
        this.$message.error(this.error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
